// extracted by mini-css-extract-plugin
export default {"rating":"iC-z","numberOfStars":"jC-z","count":"kC-z","barGraphSpacing":"lC-z","barGraph":"mC-z"};